/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useMemo } from "react";
import Container from "../../../../components/Container/Container";
import Layout from "../../../Layouts/Layout";
import PartnerLogoSection from "../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import LandingPageTeaser from "../../../../components/Teaser/LandingPageTeaser";
import AttorneySection from "../../../../components/Sections/Generic/AttorneySection/AttorneySection";
import FamilyLawConsultingCheckin from "../../../../components/Checkin/FamilyLawCheckin/Consulting/FamilyLawConsultingCheckin";
import { defaultProvenExpertTeaserCard } from "../../../../services/landingPageService";
import LinkedCardBox from "../../../../components/LinkedCardBox/LinkedCardBox";
import GreyBackgroundWrapper from "../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import LpFamilyLawConsultingAdvoCardMeta from "./AdvoCard/LpFamilyLawConsultingAdvoCardMeta";
import LpFamilyLawConsultingAragMeta from "./Arag/LpFamilyLawConsultingAragMeta";
import LpFamilyLawConsultingDeuragMeta from "./Deurag/LpFamilyLawConsultingDeuragMeta";
import iconAttorneys from "../../../../assets/icons/generic/IconLawyers";
import iconDocument from "../../../../assets/icons/generic/IconDocument";
import { useCustomer } from "../../../../provider/Customer/CustomerProvider";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";
import HowItWorksSectionConsulting from "../../../../components/Sections/FamilyLaw/Consulting/HowItWorksSection/HowItWorksSectionConsulting";
import { PARTNER_IRIS } from "../../../../constants/partnerIris";

const getMetaDataByPartner = ({ partner }: { partner: string }) => {
  switch (partner) {
    case PARTNER_IRIS.ADVOCARD:
      return <LpFamilyLawConsultingAdvoCardMeta />;
    case PARTNER_IRIS.ARAG:
      return <LpFamilyLawConsultingAragMeta />;
    case PARTNER_IRIS.DEURAG:
      return <LpFamilyLawConsultingDeuragMeta />;
    default:
      return null;
  }
};

const LpFamilyLawConsultingPartner = ({ partner }: { partner: NonNullable<AbstractCase["acquisitionPartner"]> }) => {
  const { isLoggedIn } = useCustomer();
  const metaData = useMemo(() => getMetaDataByPartner({ partner }), [partner]);

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      {metaData}
      <LandingPageTeaser
        teaserButtonText={"Jetzt Starten"}
        headline={"Professionelle Hilfe im Familienrecht"}
        subheadline={"Kurz Anliegen schildern und Gespräch vereinbaren"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox
          linkedCards={[
            defaultProvenExpertTeaserCard,
            {
              icon: iconAttorneys,
              heading: "Professionelle Beratung",
            },
            {
              icon: iconDocument,
              heading: "Unkomplizierte Abwicklung",
            },
          ]}
        />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={partner} containerStyle={"settlementContainer"} />
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <FamilyLawConsultingCheckin idPrefix={"top"} partner={partner} />
          </Container>
        )}
        <HowItWorksSectionConsulting />
      </GreyBackgroundWrapper>
      <AttorneySection
        textCards={false}
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        heading={"Deutschlandweit tätige Partneranwälte"}
      />
      {!isLoggedIn && (
        <Container>
          <FamilyLawConsultingCheckin idPrefix={"top"} partner={partner} />
        </Container>
      )}
    </Layout>
  );
};

export default LpFamilyLawConsultingPartner;
